import { useEffect, useState, useCallback } from "react";
import { expAssign, expConvert } from "@/lib/api";

// Persist a stable, anonymous visitor id so variant assignment is sticky.
function visitorId() {
  try {
    let v = localStorage.getItem("wt_visitor");
    if (!v) { v = `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`; localStorage.setItem("wt_visitor", v); }
    return v;
  } catch { return "anon"; }
}

/**
 * Conversion Lab hook. Assigns a variant for `key` (sticky per visitor), counts
 * one impression, and returns { content, track }. `content` is the variant's
 * overrides ({} for control), so callers fall back to their own defaults safely.
 */
export function useExperiment(key) {
  const [state, setState] = useState({ ready: false, variant: null, content: {} });

  useEffect(() => {
    let cancelled = false;
    expAssign(key, visitorId())
      .then((d) => { if (!cancelled) setState({ ready: true, variant: d.variant, content: d.content || {} }); })
      .catch(() => { if (!cancelled) setState({ ready: true, variant: null, content: {} }); });
    return () => { cancelled = true; };
  }, [key]);

  const track = useCallback(() => {
    if (state.variant) expConvert(key, visitorId(), state.variant).catch(() => {});
  }, [key, state.variant]);

  return { ...state, track };
}
